// extracted by mini-css-extract-plugin
module.exports = {"conteiner":"FormRegisterTwo_conteiner__2Tdyd"};